import styled from "styled-components";

type ItemType = {
    color: string;
    borderColor: string;
    backgroundColor: string;
}

type HorizontalListType = {
    paddingWidth: number;
}

type LabelType = {
    color: string;
}

type ContainerType = {
    border: string;
    background: string;
}

type ClearButtonType = {
    color: string;
}

export const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    box-sizing: border-box;
`;

export const Container = styled.div<ContainerType>`
    display: flex;
    flex-direction: row;
    flex: 1;
    min-height: 48px;
    align-items: center;
    gap: 12px;
    padding: 8px 16px;
    border: 1px solid ${(props) => props.border};
    border-radius: 10px;
    background: ${(props) => props.background};
    box-sizing: border-box;
`;

export const HorizontalList = styled.div<HorizontalListType>`
    width: 0;
    min-width: 0;
    box-sizing: border-box;
    flex: 1;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior-x: contain;
`;

export const HorizontalRow = styled.div`
  display: inline-flex;
  gap: 8px;
  flex-wrap: nowrap;
  width: max-content;
  align-items: center;
`;

export const HorizontalItem = styled.div<ItemType>`
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    white-space: nowrap;
    flex-direction: row;
    padding: 6px 10px;
    border-radius: 8px;
    border: ${(props) => `1px solid ${props.borderColor}`};
    font-size: 12px;
    color: ${props => props.color};
    background:${props => props.backgroundColor};
`;

export const TextEllipsis = styled.div`
    white-space: nowrap;
    display: block;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 300px;
`;

export const ChipLabel = styled.span`
    font-weight: 700;
`;

export const ChipValue = styled.span`
    font-weight: 400;
`;

export const Label = styled.span<LabelType>`
    font-weight: 700;
    font-size: 14px;
    color: ${props => props.color};
    letter-spacing: 0.2px;
    white-space: nowrap;
    flex-shrink: 0;
`;

export const ClearButton = styled.button<ClearButtonType>`
    border: none;
    background: transparent;
    color: ${(props) => props.color};
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    white-space: nowrap;
    padding: 0;
    margin-left: 8px;
    flex-shrink: 0;

    &:hover {
        text-decoration: underline;
    }
`;
